export const GRIPS_DEVICE_PARAM = 'device';
export const GRIPS_DEVICE_IOS_APP = 'ios';
export const GRIPS_DEVICE_ANDROID_APP = 'android';
